export default {"src":"/_next/static/media/SubDesc3.7720e8ec.svg","height":121,"width":120,"blurWidth":0,"blurHeight":0};